var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Rate',{attrs:{"allow-half":_vm.allowHalf,"disabled":_vm.disabled,"show-score":_vm.showScore,"score-template":`${_vm.score.toFixed(1)}`},on:{"change":_vm.rateChange},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }